
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'FImage'
})
class FImage extends Vue {
  @Prop() readonly src!: string
  @Prop() readonly filename!: string
  @Prop() readonly contextMenu?: boolean

  private openInNewTab(): void {
    window.open(this.src, '_blank')
  }
}

export default FImage
